// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c39dbd69","453":"d3867c7c","455":"a15095a5"}[chunkId] + ".chunk.js";
};